import React from "react";

import TeamLayout from "../components/TeamComp";
import SEO from "../components/seo";
import img1 from "../images/Suhas_Motwani.jpeg";
import img2 from "../images/Karan_Prasad.jpeg";
import img3 from "../images/Akshay_Deogiri.jpeg";
import img4 from "../images/Akash_Kathavate.jpeg";
import img5 from "../images/Kavya_N.jpeg";
import img6 from "../images/Nihal_Navada.jpeg";
import img7 from "../images/Shreyas_Kamath.jpeg";
import img8 from "../images/Shreyas_P_S.jpeg";
import img9 from "../images/Bhoomika_M.jpeg";
import img10 from "../images/Nihal_Desai.jpeg";
import img11 from "../images/Pradyumna_Rahul_K.jpeg";
import img12 from "../images/Shivangi_Balodia.jpeg";
import img13 from "../images/Sai_Pranav_P.jpeg";
import img14 from "../images/Soukhya_SK.jpeg";





function Team() {

  return (
    <TeamLayout
    title="THE TEAM"
    brief="Every worthwhile quest involves a bunch of people, going the extra mile, moving mountains, and making the impossible seem doable. Here are the people behind the BMSCE Alumni Club!"
    members={
      [
      
      {
        "name":"Suhas Motwani",
        "desc":"Business Analyst @ PepsiCo",
        "linkedin":"https://www.linkedin.com/in/suhasmotwani/",
        "image": img1
      },
      {
        "name":"Karan Prasad",
        "desc":"Business Development Representative @ DigitalOcean",
        "linkedin":"https://www.linkedin.com/in/karan-prasad/",
        "image": img2
      },
      {
        "name":"Akshay Deogiri",
        "desc":"SEO Outreach Specialist @ MobStac",
        "linkedin":"https://www.linkedin.com/in/akshaydeogiri/",
        "image": img3
      },
      {
        "name":"Akash Kathavate",
        "desc":"Software Developer @ Bidgely Technologies",
        "linkedin":"https://www.linkedin.com/in/akash-kathavate/",
        "image": img4
      },
      {
        "name":"Kavya N",
        "desc":"Software Engineer @ McAfee",
        "linkedin":"https://www.linkedin.com/in/kavya-nagendra-246993b4/",
        "image": img5
      },
      {
        "name":"Nihal Navada",
        "desc":"Application Engineer @ Renesas Electronics America",
        "linkedin":"https://www.linkedin.com/in/nihalmnavada/",
        "image": img6
      },
      {
        "name":"Shreyas Kamath",
        "desc":"Engineer @ QuEST Global",
        "linkedin":"https://www.linkedin.com/in/shreyaskamath13/",
        "image": img7
      },
    
      {
        "name":"Shreyas P S",
        "desc":"Mechanical Engineer",
        "linkedin":"https://www.linkedin.com/in/shreyas-ps/",
        "image": img8
      },
      {
        "name":"Bhoomika M",
        "desc":"Research and Development Engineer @ Synopsys Inc",
        "linkedin":"https://www.linkedin.com/in/bhoomika-m-752963102/",
        "image": img9
      },
      {
        "name":"Nihal Desai",
        "desc":"Application Development Analyst @ Accenture",
        "linkedin":"https://www.linkedin.com/in/nihal-desai-425359192/",
        "image": img10
      },
      {
        "name":"Pradyumna Rahul K",
        "desc":"Information Science and Engineering student @ BMSCE",
        "linkedin":"https://www.linkedin.com/in/pradyumnarahulk/",
        "image": img11
      },
     
      {
        "name":"Shivangi Balodia",
        "desc":"Computer Science and Engineering student @ BMSCE",
        "linkedin":"https://www.linkedin.com/in/shivangibalodia807/",
        "image": img12
      },
      {
        "name":"Sai Pranav P",
        "desc":"Industrial Engineering and Management student @ BMSCE",
        "linkedin":"https://www.linkedin.com/in/saipranavp/",
        "image": img13
      },
      {
        "name":"Soukhya SK",
        "desc":"Industrial Engineering and Management student @ BMSCE",
        "linkedin":"https://www.linkedin.com/in/soukhya-s-k-b3616b1a7/",
        "image": img14
      }
      // {
      //   "name":"Diwakar",
      //   "desc":"Co-Founder @ Kaarz",
      //   "linkedin":"https://www.linkedin.com/in/shreyas-ps/",
      //   "image": a10
      // }
      ]
    }
  
  >
  
    <SEO
      title="Team:BMSCE Alumni Club"
      keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
    />

  </TeamLayout>
  );
}

export default Team;
